import cryptoJs from "crypto-js";

export const base64Encrypt = rawStr => {
  const wordArray = cryptoJs.enc.Utf8.parse(rawStr);
  const base64 = cryptoJs.enc.Base64.stringify(wordArray);
  return base64;
};
